<div *ngIf="event && module && form && myEventUser" class="background" [class.full-w]="componentMode">
	<div class="header">
		<div [ngClass]="device === 'ios' ? 'ios-close-btn' : 'close-btn'" class="p-l-5 p-t-15">
			<ion-button fill="clear" color="dark" (click)="closeModal('cancelled')">
				<ion-icon color="danger" src="assets/icon/Close.svg"></ion-icon>
			</ion-button>
		</div>
		<!-- Form title -->
		<div class="title">
			<h1 class="title-text-main" [style.color]="event.styling.titleColor">{{ form.name[currentLanguage] }}</h1>
			<h1 class="title-text-sub" [style.color]="event.styling.contentTextColor">
				({{
					contactDatas.length > 0
						? ("labels.contact-editing" | translate)
						: ("labels.contact-creation" | translate)
				}})
			</h1>
			<br />
		</div>
	</div>

	<!-- content -->
	<div
		[style.overflow-y]="isMobile && componentMode ? 'visible' : 'scroll'"
		[style.marginTop]="isMobile && componentMode ? '30px' : '10px'"
		class="content"
	>
		<form [formGroup]="fieldsForm" style="background-color: #fff">
			<div *ngFor="let field of form.fields; let i = index" style="padding-top: 10px">
				<div
					*ngIf="field.visibility"
					[ngStyle]="{
						'border-bottom':
							i !== form.fields.length - 1 ? '1px solid ' + event.styling.titleColor + '4D' : 'none',
						'padding-bottom': '10px'
					}"
				>
					<ion-label
						*ngIf="field.optionalName && field?.optionalName[currentLanguage] && field.type !== 'plainText'"
						class="field-title-main ion-text-wrap ion-text-left"
						style="width: 100%; margin-left: 10px"
						[style.color]="event.styling.titleColor"
					>
						{{ field.optionalName[currentLanguage] }}
					</ion-label>
					<div
						[class.evaluation-box]="field.type === 'evaluation' || field.type === 'document'"
						[class]="field.type === 'document' ? 'document-container' : ''"
					>
						<div class="field-title-infobooth">
							@if (field.type !== "plainText") {
								<p
									class="field-title ion-text-wrap"
									style="width: 100%"
									[style.color]="event.styling.titleColor"
								>
									{{ field.name[currentLanguage] }}
								</p>
							}

							<div class="infobooth" *ngIf="field.description && field.description[currentLanguage]">
								<small [style.color]="event.styling.contentTextColor">
									<p [innerHTML]="field.description[currentLanguage] | safeHtml"></p>
								</small>
							</div>
						</div>
						<div class="fields-to-user" *ngIf="field.type === 'oneSelect'">
							<ion-list>
								<ion-radio-group [style.opacity]="1" [formControlName]="field.uid" [name]="field.uid">
									@for (option of field.answers; track option; let ind = $index) {
										<div
											class="tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-px-[40px] tw-cursor-pointer tw-min-h-[56px]"
											[style.border-bottom]="
												ind !== field.answers.length - 1 ? '1px solid #e5e5e5' : 'none'
											"
											(click)="fieldsForm.get(field.uid).setValue(option.uid)"
										>
											<div class="tw-w-full tw-flex tw-flex-row tw-justify-start tw-items-center">
												<ion-label
													class="option-size ion-text-wrap"
													[style.color]="event.styling.contentTextColor"
												>
													{{ option.answer[currentLanguage] }}
												</ion-label>
											</div>
											<ion-radio mode="md" legacy="true" [value]="option.uid"></ion-radio>
										</div>
									}
								</ion-radio-group>
							</ion-list>
						</div>

						<div [formGroupName]="field.uid" class="fields-to-user" *ngIf="field.type === 'multipleSelect'">
							<ion-list>
								@for (answer of field.answers; track answer; let ind = $index) {
									<div
										class="tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-px-[40px] tw-cursor-pointer tw-min-h-[56px]"
										[style.border-bottom]="
											ind !== field.answers.length - 1 ? '1px solid #e5e5e5' : 'none'
										"
										(click)="
											fieldsForm
												.get(field.uid)
												.get(answer.uid)
												.setValue(!fieldsForm.get(field.uid).get(answer.uid).value)
										"
									>
										<div class="tw-w-full tw-flex tw-flex-row tw-justify-start tw-items-center">
											<ion-label
												class="option-size ion-text-wrap"
												[style.color]="event.styling.contentTextColor"
											>
												{{ answer?.answer[currentLanguage] }}
											</ion-label>
										</div>
										<ion-checkbox
											(click)="
												fieldsForm
													.get(field.uid)
													.get(answer.uid)
													.setValue(!fieldsForm.get(field.uid).get(answer.uid).value)
											"
											[formControlName]="answer.uid"
										></ion-checkbox>
									</div>
								}
							</ion-list>
						</div>

						<div class="justify-text evaluation" lines="none" *ngIf="field.type === 'evaluation'">
							<div class="evaluation-align">
								<ngx-star-rating [style.opacity]="1" [formControlName]="field.uid" [id]="field.uid">
								</ngx-star-rating>
							</div>
						</div>

						<div class="fields-to-user" *ngIf="field.type === 'dissertative'">
							<ion-list>
								<ion-item class="ion-text-wrap" lines="none">
									<ion-textarea
										autocapitalize="sentences"
										[style.opacity]="1"
										[formControlName]="field.uid"
										[name]="field.uid"
										placeholder="{{ 'surveys.answer_plc' | translate }}"
										style="--padding-start: 10px"
									>
									</ion-textarea>
								</ion-item>
							</ion-list>
						</div>

						<div class="fields-to-user" *ngIf="field.type === 'plainText'">
							<div class="plain-text-container">
								<div class="plain-text-content" [innerHTML]="fieldsForm.get(field.uid).value"></div>
							</div>
						</div>

						<div class="fields-to-user" *ngIf="field.type === 'date'">
							<!-- <ion-item class="ion-text-wrap" lines="none"> -->
							<ion-datetime
								style="margin: auto"
								presentation="date"
								[formControlName]="field.uid"
								[name]="field.uid"
								min="1900-01-01"
								max="2050-01-01"
								[locale]="locale"
							>
							</ion-datetime>
							<!-- </ion-item> -->
						</div>

						<!-- Document form -->
						<div
							style="margin: auto"
							class="fields-to-user document-type-question"
							*ngIf="field.type === 'document'"
						>
							<div class="document-actions">
								<!-- Document Item Container -->
								<div class="document-item-container" [class.is-mobile]="isMobile">
									<label
										style="cursor: pointer"
										[matTooltip]="
											fieldsForm.get(field.uid).value
												? 'tooltips.click-to-replace-document'
												: ('buttons.click-to-select-document' | translate)
										"
										for="document_field_{{ field.uid }}"
									>
										<!-- If there's a preview (image), show it -->
										<ng-container *ngIf="getDocumentPreviewUrl(field.uid); else genericIcon">
											<ion-thumbnail
												class="field-document-img"
												style="width: 200px; height: 200px"
												slot="start"
											>
												<img
													[src]="getDocumentPreviewUrl(field.uid)"
													class="field-document-img"
													alt="{{ getDocumentName(field.uid) || 'Document Preview' }}"
												/>
											</ion-thumbnail>
										</ng-container>
										<!-- If no preview or non-image file, show the appropriate icon -->
										<ng-template #genericIcon>
											<ion-thumbnail
												class="field-document-img"
												style="width: 200px; height: 200px"
												slot="start"
												*ngIf="
													fieldsForm.get(field.uid).value || hasPendingFile(field.uid);
													else importerIcon
												"
											>
												<img
													[src]="'/assets/icon/Files/' + getAssetFileName(field.uid) + '.svg'"
													class="field-document-img"
													alt="{{ 'File Icon' }}"
												/>
											</ion-thumbnail>
											<ng-template #importerIcon>
												<img
													src="/assets/images/importer.png"
													class="field-document-img"
													alt="{{ 'buttons.click-to-select-document' | translate }}"
												/>
											</ng-template>
										</ng-template>
									</label>
									<!-- Delete document icon (now inside container) -->
									<ion-icon
										*ngIf="fieldsForm.get(field.uid).value || hasPendingFile(field.uid)"
										(click)="deleteDocument(field)"
										name="trash"
										class="delete-document-icon"
										[style.color]="'#dc3545'"
										matTooltip="{{ 'tooltips.click-to-delete-document' | translate }}"
									></ion-icon>
								</div>
								<!-- End Document Item Container -->

								<div class="document-controls">
									<!-- Download icon (remains outside hover container) -->
									<ion-icon
										*ngIf="
											getresultOfField(field) &&
											getresultOfField(field).document &&
											getresultOfField(field).document?.url !== ''
										"
										(click)="
											downloadDocument(
												getresultOfField(field).document.url,
												getDocumentName(field.uid)
											)
										"
										name="cloud-download"
										class="download-icon"
										[style.color]="event.styling.titleColor"
										matTooltip="{{ 'tooltips.click-to-download-document' | translate }}"
									></ion-icon>
								</div>
							</div>

							<!-- <ion-label *ngIf="getresultOfField(field) && getresultOfField(field).document">{{
                getresultOfField(field) && getresultOfField(field).document
                ? getresultOfField(field).document.name
                : ""
                }}
              </ion-label> -->
							<div class="upload-btn-wrapper">
								<input
									id="document_field_{{ field.uid }}"
									type="file"
									class="file-input"
									[accept]="SDocument.supportedExtensions"
									(change)="getDocument($event, field)"
									style="display: none"
								/>
								<span *ngIf="!fieldsForm.get(field.uid).value && !hasPendingFile(field.uid)">
									{{ "buttons.click-to-select-document" | translate }}</span
								>
								<span *ngIf="fieldsForm.get(field.uid).value || hasPendingFile(field.uid)">
									{{ getDocumentName(field.uid) }}</span
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>

	<!-- Footer -->
	<div class="footer">
		<!-- @if (formLoader()) {
    <ion-spinner name="lines" class="spinner"></ion-spinner>
    } -->

		<div [style.position]="isMobile ? 'absolute' : 'relative'" style="bottom: 0; text-align: center; width: 100%">
			@if (!loadingSend) {
				<button
					type="button"
					shape="round"
					class="btn-validate"
					[style.background]="event.styling.btnBgColor"
					[class.disbaled]="fieldsForm.invalid || formLoader()"
					[style.color]="event.styling.btnTextColor"
					[disabled]="fieldsForm.invalid || formLoader()"
					(click)="sendForm()"
					[class.button-spinner]="formLoader()"
				>
					@if (!formLoader()) {
						<span>{{ "buttons.answer" | translate }}</span>
					}
				</button>
			}
		</div>
	</div>

	<br />
</div>

<div class="align-loader-custom" *ngIf="componentLoader">
	<div class="loader-default"></div>
</div>
